import React, { Fragment } from 'react';

import useClubRecognitionCategoryMeasure from './UseClubRecognitionCategoryMeasure';

import ClubRecognitionCategoryMeasureHeader from './components/ClubRecognitionCategoryMeasureHeader';

import DropdownView from '../../../components/views/dropdownView/DropdownView';

import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

import Constants from '@usas/ui-web/utils/Constants';
import PageNotFound from '@usas/ui-web/components/PageNotFound';

const ClubRecognitionDropdown = () => {
  const {
    isLoading,
    programFocusState,
    onRedirectToCategory
  } = useClubRecognitionCategoryMeasure();

  if (!programFocusState || Object.keys(programFocusState?.levelCategoryObj).length === 0 ||
    Object.keys(programFocusState?.programLevelObj).length === 0) {
    return (
      <PageNotFound />
    );
  }

  return (
    <Fragment>
      <ClubRecognitionCategoryMeasureHeader
        programCategory={programFocusState.levelCategoryObj}
        categoryMeasure={programFocusState.categoryMeasureObj}
        onBackClicked={onRedirectToCategory} />
      <div className="row">
        <div className="col-xs-12">
          <DropdownView
            programLevel={programFocusState.programLevelObj}
            categoryMeasure={programFocusState.categoryMeasureObj}
            onRedirect={onRedirectToCategory} />
        </div>
      </div>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isLoading} />
    </Fragment>
  );
};

export default ClubRecognitionDropdown;